import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import SplashScreen from './screens/SplashScreen';
import MobileEntry from './screens/MobileEntry';
import OtpVerify from './screens/OtpVerify';
import CreateAccount from './screens/CreateAccount';
import SetPin from './screens/SetPin'
import MainHome from './screens/MainHome';
import EcommerceHome from './screens/EcommerceHome';
import EcommerceCart from './screens/EcommerceCart';
import EcommerceCheckout from './screens/EcommerceCheckout';
import EcommerceOrderHistory from './screens/EcommerceOrderHistory';
import RefundPolicy from './screens/RefundPolicy';
import FundsScreen from './screens/FundsScreen';
import MyBidsScreen from './screens/MyBidsScreen';
import PassbookScreen from './screens/PassbookScreen';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SupportScreen from './screens/SupportScreen';
import SetNewPinScreen from './screens/SetNewPin';
import NotificationsScreen from './screens/NotificationScreen';
import Videos from './screens/Videos';
import NoticeRules from './screens/NoticeRules'
import GameRatesScreen from './screens/GameRates';
import ChartsScreen from './screens/Chart';
import SubmitIdeaScreen from './screens/SubmitIdeas';
import SettingsScreen from './screens/Settings';
import ShareApp from './screens/Share';
import ChartDetail from './screens/chartDetail';
import AddFundScreen from './screens/AddFunds';
import WithdrawFundsScreen from "./screens/WithdrawFunds";
import AddBankDetailsScreen from "./screens/AddBankDetails";
import DepositHistoryScreen from "./screens/DepositHistory";
import WithdrawHistoryScreen from './screens/WithdrawHistory';
import KingJackpotScreen from './screens/KingJackpot';
import KingStarlineDashboard from './screens/KingStarline';
import KingJackpotResultHistory from './screens/ResultHistoryJackpot';
import KingStarlineResultHistory from './screens/ResultHistoryStarline';
import LoginWithMPin from './screens/LoginWithMpin';
import PrivateRoute from './components/PrivateRoute';
import OpenGame from './screens/OpenGame';
import BidHistoryScreen from './screens/BidHistory';
import SBidHistory from './screens/StarlineHistory';
import JBidHistory from './screens/JackpotHistory';
import  StarlineGames from './screens/StarlineGames';
import JackpotGames from './screens/JackpotGame'
import { DeleteAccountPolicy, PrivacyPolicy, TermsConditions } from './screens/LegalPages';
import { useAppContext } from './context/AppContext';




import BidGames from './games/BidGames';

const ECOMMERCE_ONLY = false;
const ecommerceHomeRedirect = <Navigate to="/home" replace />;

function HomeRoute() {
  const { isInactive } = useAppContext();
  return isInactive ? <EcommerceHome /> : <MainHome />;
}

function App() {
  return (
      <Router>
      <div className="appp-wrapper">
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/enter-mobile" element={<MobileEntry />} />
        <Route path="/verify-otp" element={<OtpVerify />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/set-pin" element={<SetPin />} />
       

         <Route
          path="/home"
          element={
            <PrivateRoute>
              <HomeRoute />
            </PrivateRoute>
          }
          
        />

        <Route path="/funds" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><FundsScreen /> </PrivateRoute>} />
        <Route path="/bids" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><MyBidsScreen /></PrivateRoute>} />
        <Route path="/passbook" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PassbookScreen />} />
        <Route path="/support" element={<SupportScreen />} />
        <Route path="/set-new-pin" element={<SetNewPinScreen />} />
        <Route path="/notifications" element={<NotificationsScreen />} />
        <Route path="/videos" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <Videos />} />
        <Route path="/rules" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <NoticeRules />} />
        <Route path="/rates" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <GameRatesScreen />} />
        <Route path="/charts" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <ChartsScreen/>} />
        <Route path="/submit-idea" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <SubmitIdeaScreen/>} />
        <Route path="/share" element={<ShareApp/>} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/delete-account" element={<DeleteAccountPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cart" element={<PrivateRoute><EcommerceCart /></PrivateRoute>} />
        <Route path="/checkout" element={<PrivateRoute><EcommerceCheckout /></PrivateRoute>} />
        <Route path="/order-history" element={<PrivateRoute><EcommerceOrderHistory /></PrivateRoute>} />
        <Route path="/charts/:gameType/:gameId/:chartName" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <ChartDetail />} />
        <Route path="/charts/:gameId/:chartName" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <ChartDetail />} />
        <Route path="/funds/add" element={<AddFundScreen />} />
        <Route path="/funds/withdraw" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><WithdrawFundsScreen /></PrivateRoute>} />
        <Route path="/funds/addBankDetails" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <AddBankDetailsScreen />} />
        <Route path="/funds/depositHistory" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <DepositHistoryScreen />} />
        <Route path="/funds/WithdrawHistory" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <WithdrawHistoryScreen />} />
        <Route path="/king-jackpot" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><KingJackpotScreen/></PrivateRoute>} />
        <Route path="/king-starline" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><KingStarlineDashboard/></PrivateRoute>} />
     
        <Route path="/login-with-mpin" element={<LoginWithMPin/>} />
        <Route path="/market/:marketId" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <OpenGame />} />
        <Route path='/bid-history' element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <BidHistoryScreen/>}/>
        <Route path='/starline-bid-history' element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <SBidHistory/>}/>
        <Route path='/jackpot-bid-history' element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <JBidHistory/>}/>
            
          {/* GAMESSSS */}

         <Route path="/bid/:marketType/:marketId/:gameType" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <PrivateRoute><BidGames /></PrivateRoute>} />

         <Route path="/starline/:marketId" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <StarlineGames />} />
          <Route path="/jackpot/:marketId" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <JackpotGames />} />


        <Route path="/bids/jackpot-result-history" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <KingJackpotResultHistory/>} />
        <Route path="/bids/starline-result-history" element={ECOMMERCE_ONLY ? ecommerceHomeRedirect : <KingStarlineResultHistory/>} />


      </Routes>
       <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </Router>
  );
}

export default App;
